import { render } from "./HumburgerMenu.vue?vue&type=template&id=2a578ed9&scoped=true"
import script from "./HumburgerMenu.vue?vue&type=script&lang=js"
export * from "./HumburgerMenu.vue?vue&type=script&lang=js"

import "./HumburgerMenu.vue?vue&type=style&index=0&id=2a578ed9&scoped=true&lang=css"

import exportComponent from "/home/aungkhantkoko/Desktop/PortFolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a578ed9"]])

export default __exports__